/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



//   const closeButton = document.querySelector('.search-bar__close-button');

//   const header = document.querySelector('header');
//   const searchWrapper = document.querySelector('.header__search-bar-wrapper');

//   closeButton.addEventListener('click', () => {
//     header.classList.remove('header--middle', 'header--search-expanded');
//     searchWrapper.classList.remove('is-visible');
//   });

// SEARCH CLOSE BUTTON 

jQuery(document).ready(function($) {
  $('.search-bar__close-button').on('click', function() {
  $('header').removeClass('header--middle header--search-expanded');
  $('.header__search-bar-wrapper').removeClass('is-visible');
});
});



//  search icon bar 
$('.header-search-icon').on('click', function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  $('header').toggleClass('header--middle header--search-expanded');
  $('.header__search-bar-wrapper').toggleClass('is-visible');
});

// mini cart icon 
document.addEventListener('click', function (e) {
  if (!e.target.closest('.js-mini-cart-close')) return;

  e.preventDefault();

  /*  trigger header cart toggle */
  const headerCartToggle =
    document.querySelector('[data-action="toggle-mini-cart"]') ||
    document.querySelector('.header__cart-toggle');

  if (headerCartToggle) {
    headerCartToggle.click();
  }
});





